/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ClassroomdisciplineId202,
  PutApiV1ClassroomdisciplineId400,
  PutApiV1ClassroomdisciplineId401,
  PutApiV1ClassroomdisciplineId404,
  PutApiV1ClassroomdisciplineId500,
  PutApiV1ClassroomdisciplineIdMutationRequest,
  PutApiV1ClassroomdisciplineIdMutationResponse,
  PutApiV1ClassroomdisciplineIdPathParams,
} from "../../types/classPlanningController/PutApiV1ClassroomdisciplineId.ts";
import { updateClassroomDisciplineViewModelSchema } from "../updateClassroomDisciplineViewModelSchema.ts";

export const putApiV1ClassroomdisciplineIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1ClassroomdisciplineIdPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ClassroomdisciplineId202Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ClassroomdisciplineId400Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ClassroomdisciplineId401Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ClassroomdisciplineId404Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ClassroomdisciplineId500Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineId500>;

export const putApiV1ClassroomdisciplineIdMutationRequestSchema = z.lazy(
  () => updateClassroomDisciplineViewModelSchema,
) as unknown as ToZod<PutApiV1ClassroomdisciplineIdMutationRequest>;

export const putApiV1ClassroomdisciplineIdMutationResponseSchema = z.lazy(
  () => putApiV1ClassroomdisciplineId202Schema,
) as unknown as ToZod<PutApiV1ClassroomdisciplineIdMutationResponse>;
